<template lang="pug">
    div.mx-3
         v-alert(color="red lighten-2",dark) {{ $t("WIP") }}
</template>

<script>
export default {
  name:"WIP"
}
</script>